import React, { useState, useEffect } from "react";
import { FaArrowLeft } from "react-icons/fa";
import { apiPut } from "../../API/Api_Url";
import { toast } from "react-toastify";
import LocationMap from "./LocationMap";

const UpdateServiceRequirementModal = ({ requirementData, isOpen, onClose, GetUserAllPendingRequirements }) => {
    const [AllServiceTypes] = useState([
        { _id: "1", Name: "Architect" },
        { _id: "2", Name: "Structural Designer" },
        { _id: "3", Name: "Cad Drawings (2D/3D, Sketchup)" },
        { _id: "4", Name: "Plumbing" },
        { _id: "5", Name: "Electrical Services" },
        { _id: "6", Name: "Home Interior Designer" },
    ]);

    const [ServiceType, setServiceType] = useState("");
    const [Whendoyouneedtheservice, setWhendoyouneedtheservice] = useState("");
    const [State, setState] = useState("");
    const [City, setCity] = useState("");
    const [Pincode, setPincode] = useState("");
    const [LocationAddress, setLocationAddress] = useState("");
    const [Latitude, setLatitude] = useState("18.9388");
    const [Longitude, setLongitude] = useState("72.8354");
    const [Budget, setBudget] = useState("");
    const [PaymentMethod, setPaymentMethod] = useState("");

    const [IsLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (requirementData) {
            setServiceType(requirementData.ServiceType || "");
            setWhendoyouneedtheservice(requirementData.Whendoyouneedtheservice || "");
            setState(requirementData.State || "");
            setCity(requirementData.City || "");
            setPincode(requirementData.Pincode || "");
            setLocationAddress(requirementData.Location?.Address || "");
            setLatitude(requirementData.Location?.Lat || "18.9388");
            setLongitude(requirementData.Location?.Long || "72.8354");
            setBudget(requirementData.Budget || "");
            setPaymentMethod(requirementData.PaymentMethod || "");
        }
    }, [requirementData]);

    const [errors, setErrors] = useState({});

    const handleUpdateRequirementSubmit = async () => {

        let newErrors = {};

        if (!ServiceType) newErrors.ServiceType = "Service Type is required";
        if (!Whendoyouneedtheservice) newErrors.Whendoyouneedtheservice = "When do you need the service is required";
        if (!State) newErrors.State = "State is required";
        if (!City) newErrors.City = "City is required";
        if (!Pincode) newErrors.Pincode = "Pincode is required";
        if (!LocationAddress) newErrors.LocationAddress = "Location Address is required";
        if (!Budget) newErrors.Budget = "Budget is required";
        if (!PaymentMethod) newErrors.PaymentMethod = "Payment Method is required";

        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) return;

        try {
            setIsLoading(true);

            const payload = {
                ServiceType,
                Whendoyouneedtheservice,
                State,
                City,
                Pincode,
                Location: {
                    Address: LocationAddress,
                    Lat: Latitude,
                    Long: Longitude,
                },
                Budget,
                PaymentMethod,
            };

            const response = await apiPut(`/api/user/UpdateServiceRequirement/${requirementData?._id}`, payload);

            if (response?.data) {
                toast.success("Requirement updated successfully!");
                onClose();
                GetUserAllPendingRequirements();
            } else {
                toast.error(response?.message || "Failed to update requirement");
            }
        } catch (error) {
            console.error("Error updating requirement:", error);
            toast.error("Something went wrong. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-2xl shadow-lg p-8 max-w-4xl w-full overflow-y-auto max-h-[90vh]">
                <div className="flex items-center mb-6">
                    <FaArrowLeft
                        className="mr-3 cursor-pointer text-gray-600 hover:text-gray-800 transition"
                        onClick={onClose}
                    />
                    <h2 className="text-2xl font-semibold text-gray-800">Update Requirement</h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-5 pt-5">
                    <div>
                        <label className="block mb-1 font-medium">Service Type<span className="text-red-500">*</span></label>
                        <select
                            className={`form-input w-full ${errors?.ServiceType ? "border-red-500" : ""}`}
                            value={ServiceType}
                            onChange={(e) => setServiceType(e.target.value)}
                        >
                            <option value="">Select Service Type</option>
                            {AllServiceTypes?.map((type) => (
                                <option key={type?._id} value={type?.Name}>
                                    {type?.Name}
                                </option>
                            ))}
                        </select>
                        {errors?.ServiceType && <p className="text-red-500 text-sm mt-1">{errors?.ServiceType}</p>}
                    </div>

                    <div>
                        <label className="block mb-1 font-medium">When do you need the service? <span className="text-red-500">*</span></label>
                        <select
                            className={`form-input w-full ${errors?.Whendoyouneedtheservice ? "border-red-500" : ""}`}
                            value={Whendoyouneedtheservice}
                            onChange={(e) => setWhendoyouneedtheservice(e.target.value)}
                        >
                            <option value="">Select</option>
                            <option value="Immediate">Immediate</option>
                            <option value="Within a week">Within a week</option>
                            <option value="Within a month">Within a month</option>
                            <option value="Flexible">Flexible</option>
                        </select>
                        {errors?.Whendoyouneedtheservice && <p className="text-red-500 text-sm mt-1">{errors?.Whendoyouneedtheservice}</p>}
                    </div>
                    <div className="md:col-span-2">
                        <label className="block mb-2 font-medium">Select Your Location</label>
                        <div className="w-full rounded-lg border p-3 shadow-sm">
                            <LocationMap
                                setLatitude={setLatitude}
                                setLongitude={setLongitude}
                                setLocationAddress={setLocationAddress}
                                setCity={setCity}
                                setState={setState}
                                setPincode={setPincode}
                            />
                        </div>
                    </div>
                    <div>
                        <label className="block mb-1 font-medium">State<span className="text-red-500">*</span></label>
                        <input
                            className={`form-input w-full ${errors?.State ? "border-red-500" : ""}`}
                            type="text"
                            placeholder="Enter State"
                            value={State}
                            onChange={(e) => setState(e.target.value)}
                        />
                        {errors?.State && <p className="text-red-500 text-sm mt-1">{errors?.State}</p>}
                    </div>

                    <div>
                        <label className="block mb-1 font-medium">City<span className="text-red-500">*</span></label>
                        <input
                            className={`form-input w-full ${errors?.City ? "border-red-500" : ""}`}
                            type="text"
                            placeholder="Enter City"
                            value={City}
                            onChange={(e) => setCity(e.target.value)}
                        />
                        {errors?.City && <p className="text-red-500 text-sm mt-1">{errors?.City}</p>}
                    </div>

                    <div>
                        <label className="block mb-1 font-medium">Pincode<span className="text-red-500">*</span></label>
                        <input
                            className={`form-input w-full ${errors?.Pincode ? "border-red-500" : ""}`}
                            type="number"
                            placeholder="Enter Pincode"
                            value={Pincode}
                            onChange={(e) => setPincode(e.target.value)}
                        />
                        {errors?.Pincode && <p className="text-red-500 text-sm mt-1">{errors?.Pincode}</p>}
                    </div>

                    <div>
                        <label className="block mb-1 font-medium">Address<span className="text-red-500">*</span></label>
                        <input
                            className={`form-input w-full ${errors?.LocationAddress ? "border-red-500" : ""}`}
                            type="text"
                            placeholder="Enter Address"
                            value={LocationAddress}
                            onChange={(e) => setLocationAddress(e.target.value)}
                        />
                        {errors?.LocationAddress && <p className="text-red-500 text-sm mt-1">{errors?.LocationAddress}</p>}
                    </div>

                    <div>
                        <label className="block mb-1 font-medium">Budget<span className="text-red-500">*</span></label>
                        <input
                            className={`form-input w-full ${errors?.Budget ? "border-red-500" : ""}`}
                            type="text"
                            placeholder="Enter Budget"
                            value={Budget}
                            onChange={(e) => setBudget(e.target.value)}
                        />
                        {errors?.Budget && <p className="text-red-500 text-sm mt-1">{errors?.Budget}</p>}
                    </div>

                    <div>
                        <label className="block mb-1 font-medium">Payment Method<span className="text-red-500">*</span></label>
                        <select
                            className={`form-input w-full ${errors?.PaymentMethod ? "border-red-500" : ""}`}
                            value={PaymentMethod}
                            onChange={(e) => setPaymentMethod(e.target.value)}
                        >
                            <option value="">Select Payment Method</option>
                            <option value="Milestone">Milestone</option>
                            <option value="Monthly">Monthly</option>
                            <option value="Weekly">Weekly</option>
                            <option value="Invoice-based Payment">Invoice-based Payment</option>
                        </select>
                        {errors?.PaymentMethod && <p className="text-red-500 text-sm mt-1">{errors?.PaymentMethod}</p>}
                    </div>
                </div>

                <button
                    onClick={handleUpdateRequirementSubmit}
                    disabled={IsLoading}
                    className={`w-full mt-8 text-white py-3 rounded-full font-medium transition 
                        ${IsLoading ? "bg-gray-400 cursor-not-allowed" : "bg-gradient-to-r from-blue-500 to-red-500 hover:opacity-90"}`}
                >
                    {IsLoading ? "Updating..." : "Update Requirement"}
                </button>
            </div>
        </div>
    );
};

export default UpdateServiceRequirementModal;
